<template>
  <div>
    <div class="centered-header">
      <h3 class="ui header" style="color: #092442;">
        Visit # {{ visit.id }} 
      </h3>
    </div>

    <div class="ui divider" />
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <abstractTable
      v-else
      :data="visitInfo()"
      :definitionTable="true"
      :definitionTableWidth="'30%'"
      :classes="'ui compact definition table'"
    />
    <table class="ui celled center aligned table">
      <thead>
        <tr>
          <th>Package Name</th>
          <th>Quantities</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(visitDetail, index) in visit.visit_details"
          :class="{ positive: visitDetail.quantity > 0 }"
          :key="'visit-detail-' + index"
        >
          <td>{{ visitDetail.package_name }}</td>
          <td>{{ visitDetail.quantity || 0 }}</td>
          <td>{{ formatPrice(visitDetail.price) }}</td>
        </tr>
      </tbody>
    </table>

    
    <div 
      class="ui divider"
      v-if="!(reservationButtonStatus() == 'finished' || cancelled)"
    />
    <!-- <div
      class="ui very compact medium red button"
      style="background-color: #092442"
      @click="toggleReservation()"
      v-if="!(reservationButtonStatus() == 'finished' || cancelled)"
    >
      {{ titleCase(reservationButtonStatus().split('-')[0]) }}
    </div>
     -->
    <!-- <div
      class="ui very compact medium orange button"
      @click="goToUpdateVisit()"
      v-if="!(reservationButtonStatus() == 'finished' || cancelled)"
    >
      Update
    </div> -->

    <div
      class="ui blue right floated very compact medium right labeled icon button"
      style="background-color: #092442"
      @click="goToReservationVisit(visit.reservationVisitId)"
    >
      <i class="right arrow icon"></i>
      Show visit details
    </div>

    <div
      class="ui large longer modal"
      :id="'change-doctor-' + visit.id"
      style="margin-top: 20px !important;"
    >
      <div class="header">Change doctor for visit id # {{ visit.id }}</div>

      <div class="content">
        <div class="ui form">
          <div class="field">
            <label for="reservation_type">Choose Doctor</label>
            <select
              class="ui fluid search dropdown"
              :id="'doctor-search-' + visit.id"
              v-model="doctor_id"
              name="doctor"
            >
              <option value="">Choose Doctor</option>
              <option
                :value="doctor.id"
                v-for="doctor in doctorsMeta"
                :key="'doctor-' + doctor.id"
              >
                {{ doctor.user.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui button" @click="hideModal()">
          {{ $t('discard') }}
        </div>

        <div
          class="ui blue button"
          style="background-color: #092442"
          @click="save()"
        >
          {{ $t('save') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default
  },
  props: {
    visit: { type: Object, required: true },
    cancelled: { type: String, default: null }
  },
  data() {
    return {
      visitCancellation: {
        cancelled_at: window.moment().toDate(),
        cancellation_fee: 0,
        cancellation_reason: null
      },
      loading: false,
      wantToClear: false,
      doctor_id: null
    };
  },
  computed: {
    totalPrice() {
      return window._.sumBy(this.visit.visit_details, visitDetail => {
        return visitDetail.price;
      });
    },
    doctorProfit () {
      return window._.sumBy(this.visit.visit_costs, vc => {
        return vc.doctor_profit_as_discount ? vc.doctor_profit : 0
      })
    },
    doctorsObject() {
      return window._.keyBy(this.doctorsMeta, 'id');
    }
  },
  methods: {
    reservationButtonStatus() {
      let visitTime = window.moment(this.visit.time);
      let now = window.moment();
      let visitPassed = now > visitTime && !this.visit.started_at;

      if (visitPassed) {
        return 'start-timeOut';
      }

      if (!this.visit.started_at && !this.visit.cancelled_at) {
        return 'start';
      } else if (
        this.visit.started_at &&
        !this.visit.finished_at &&
        !this.visit.cancelled_at
      ) {
        return 'finish';
      } else {
        return 'finished';
      }
    },
    formattedTime(time) {
      if (time) {
        return window.moment(time).format('DD/MM/YYYY hh:mm a');
      }
      return '-';
    },
    visitInfo() {
      return {
        doctor: this.doctorsObject && this.visit.doctor_id
          ? this.doctorsObject[this.visit.doctor_id].user.name
          : '-',
        doctor_profit: this.doctorProfit || '-',
        reserved_time: this.formattedTime(this.visit.time),
        started_at: this.formattedTime(this.visit.started_at),
        finished_at: this.formattedTime(this.visit.finished_at),
        total_price: this.formatPrice(this.totalPrice),
        note: this.visit.note
      };
    },
    toggleReservation() {
      if (!this.visit.started_at) {
        this.$http
          .post(`reservation_visits/${this.visit.reservationVisitId}/start`, {
            clinic_id: this.getClinicId()
          })
          .then(response => {
            this.visit.started_at = response.data.started_at;
            this.$forceUpdate();
          });
      } else if (this.visit.started_at && !this.visit.finished_at) {
        //TODO: make this re route to the new component
        this.navigateTo('Finalize_visit', {
          key: 'params',
          value: {
            reservationVisitId: this.visit.reservationVisitId
          }
        });
      }
    },
    showModal() {
      $('#change-doctor-' + this.visit.id).modal('show');
      this.initGUI();
    },
    initGUI() {
      this.$nextTick(() => {
        $('#doctor-search-' + this.visit.id).dropdown();
      });
    },
    hideModal() {
      this.wantToClear = true;
      $('#change-doctor-' + this.visit.id).modal('hide');
      this.$nextTick(() => {
        this.wantToClear = false;
        this.$forceUpdate();
      });
    },
    goToReservationVisit(reservationVisitId) {
      this.navigateTo('Show_Visit', {
        key: 'params',
        value: { reservationVisitId: reservationVisitId }
      })
    },
    goToUpdateVisit() {
      this.navigateTo('Update_Visit', {
        key: 'params',
        value: { 
          visitId: this.visit.id,
          reservationId: this.visit.reservationId,
          reservationVisitId: this.visit.reservationVisitId 
        }
      })
    },
    save() {
      if (this.doctor_id) {
        this.$http
          .post(`reservation_visits/${this.visit.reservationVisitId}/change/doctor`, {
            doctor_id: this.doctor_id,
            clinic_id: this.getClinicId()
          })
          .then(response => {
            this.visit.doctor_id = response.data.doctor_id;
            this.hideModal();
          });
      }
    }
  }
};
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/reservations/reservation_components/ShowVisit.vue